module.exports = __webpack_public_path__ + "static/media/mindmeister.dc4b7f33.png";